/** Persisted values superseded by the BUI redesign; normalized to `light` on read. */
export const LEGACY_UI_THEME_IDS = [
  'old-theme',
  'new-theme',
  'old-theme-modernized',
  'default',
] as const;

export const ALLOWED_UI_THEMES = [
  'pink-raspberry-grape',
  'lavender-lime-fruit-punch',
  'blueberries-and-cream',
  'light',
  'dark',
] as const;

export type UiThemeId = (typeof ALLOWED_UI_THEMES)[number];

export const DEFAULT_UI_THEME: UiThemeId = 'light';

const allowedSet = new Set<string>(ALLOWED_UI_THEMES);
const legacySet = new Set<string>(LEGACY_UI_THEME_IDS);

export function isAllowedUiTheme(value: string): value is UiThemeId {
  return allowedSet.has(value);
}

export function normalizeUiTheme(value: string | null | undefined): UiThemeId {
  if (!value) {
    return DEFAULT_UI_THEME;
  }
  if (legacySet.has(value)) {
    return DEFAULT_UI_THEME;
  }
  if (isAllowedUiTheme(value)) {
    return value;
  }
  return DEFAULT_UI_THEME;
}
